module.exports = __webpack_public_path__ + "img/fixPrice.dd2d09a6.png";